import { z } from "zod";

const iCafeSchema = z.object({
  iCafeId: z.string().optional(),
  playncAccountId: z.string(),
  pcCafeAccount: z.string(),
  franchiseCode: z.number().optional(),
  isPrimary: z.boolean(),
  companyName: z.string(),
  companyFullName: z.string().optional(),
  companyStateCode: z.number(),
  registeredAt: z.string(),
  updatedAt: z.string(),
  sort: z.number(),
});

export type ICafeType = z.infer<typeof iCafeSchema>;
